import axios from "axios";

// @ts-expect-error no types for vue-roon-login
import RoonAuth from "@roonlabs/vue-roon-login";

export interface User {
  userid: string;
  email: string;
  groups: string[];
}

function login() {
  RoonAuth.login();
}

async function logout() {
  await axios.get("/api/logout");
  window.location.reload();
}

async function me(): Promise<User> {
  const { data } = await axios.get("/api/me");
  return data;
}

export default { login, logout, me };
